import React from 'react';
import { Animated, ScrollView } from 'react-native';

import { styles } from './styles';

interface CollapsibleBodyProps {
  children: React.ReactNode;
  ref?: React.Ref<ScrollView>;
  style?: object;
  scrollEnabled?: boolean;
}

export const CollapsibleBody: React.FC<CollapsibleBodyProps> = ({
  children,
  ref,
  style,
  scrollEnabled = true,
}) => {
  if (!scrollEnabled) {
    return <>{children}</>;
  }

  return (
    <ScrollView
      style={{ flex: 1 }}
      contentContainerStyle={{ flexGrow: 1 }}
      showsVerticalScrollIndicator={true}
      scrollEnabled={scrollEnabled}
      ref={ref}
    >
      <Animated.View style={[styles.body, style]}>{children}</Animated.View>
    </ScrollView>
  );
};
